<header class="general-header p-2">
	<div class="home-header">
		<div class="menu-btn-wrapper">
			<button class="menu-btn" (click)="openMainMenu()">
				<app-icon [iconName]="'menu-2'" />
			</button>
		</div>

		<div class="header-container">
			<!-- User Info -->
			<div class="user-info">
				<div class="user-avatar">
					<app-icon [iconName]="(auth$ | async) ? 'user-check' : 'user'" />
				</div>
				<span class="user-name">
					{{ (auth$ | async)?.nombre ?? translations['guest'] }}
				</span>
			</div>

      <!-- Location Info -->
      <div class="location-wrapper location-info" (click)="openDeliveryModal()">
        <app-icon [iconName]="'map-pin'"/>
        <span class="address-text">
          {{ getAddress() | async }}
        </span>
        <app-icon [iconName]="'chevron-down'"/>
      </div>
    </div>

		<div class="header-actions">
			<div (click)="toggleLanguage()" class="language-btn">
				<app-icon [iconName]="'language'" />
			</div>

      <div (click)="onOpenCartMenu()" class="cart-btn">
        <span class="cart-badge">{{ totalCartCount$ | async }}</span>
        <app-icon [iconName]="'shopping-cart'"/>
      </div>
    </div>
  </div>

  <div class="osahan-nav-2">
    <div class="flex flex-row align-items-center gap-4">
      <ng-container>
        <div
          (click)="openDeliveryModal()"
          class="flex flex-column w-full"
        >
          <small class="location-change-text">
            <app-icon [iconName]="'map-pin'"/>
            {{ translations['changeLocation'] }}
          </small>
          <div class="flex flex-row location-change-address">
            <span style="font-size: 10px; overflow: hidden">{{ getStoreAddress() | async }}</span>
            <app-icon [iconName]="'chevron-down'"/>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</header>
